<section class="mx-3">
  <app-toast></app-toast>
  <ng-container *ngIf="!showaddflag">
    <div>
      <div class="d-flex justify-content-between align-items-center">
        <div class="page_header">
          <h3 translate class="m-0 page_header_title">Student Details</h3>
        </div>
        <div *ngIf="actiondata?.create" class="d-flex button-row">
          <div class="px-3">
            <div class="bulk_button">
              <!-- <input
                #csvInput
                hidden="true"
                type="file"
                onclick="this.value=null"
                (change)="csvInputChange($event)"
              /> -->
              <button mat-raised-button class="bulk_button_add"
                (click)="openUploadDialog('details', 'STUDENTS_BULKUPLOAD_TEMPLATE')">
                <img src="../../../assets/icons/fileupload.svg" class="me-2" alt="upload icon" />
                <span translate>Bulk Upload</span>
              </button>
              <button mat-raised-button class="m-0 p-0 bulk_button_view" [matMenuTriggerFor]="menu">
                <i class="fa-solid fa-chevron-down"></i>
              </button>
            </div>
            <mat-menu #menu="matMenu" class="download_menu">
              <button translate mat-menu-item (click)="
                  openUploadDialog('details', 'STUDENTS_BULKUPLOAD_TEMPLATE')
                " class="">
                Upload Student Details
              </button>
              <button translate class="" mat-menu-item (click)="openUploadDialog('images', 'studentImages')">
                Upload Student Images
              </button>
            </mat-menu>
          </div>
          <div>
            <button translate mat-raised-button color="primary" (click)="showadd(true)" class="px-5 add_button">
              Add
            </button>
          </div>
        </div>
      </div>
      <ng-container *ngIf="actiondata?.list_view">
        <div class="table-container ">
          <div class="d-flex align-items-center">
            <div class="m-2 filter_icon cursor_pointer" [matMenuTriggerFor]="filterMenu"  #menuTrigger="matMenuTrigger">
              <div mat-button class="choose_button">
                 <i class="fa-solid fa-filter me-1"></i>
                <span translate> Filter </span>
              </div>
              <mat-menu #filterMenu="matMenu" (closed)="menuClosed($event)">
                <div class="p-3" (click)="$event.stopPropagation()">
                  <form [formGroup]="StudentFilterForm">
                    <div *ngFor="let question of StudentFilterFormQuestions">
                      <app-question
                        [question]="question"
                        [form]="StudentFilterForm"
                      ></app-question>
                    </div>
                    <div class="mt-2">
                      <button
                        mat-button
                        color="primary"
                        type="button"
                        (click)="filterStudents($event); menuTrigger.closeMenu()"
                      >
                        <i class="fa-solid fa-filter me-1"></i> <span translate>Filter</span>
                      </button>
                      <button
                        translate
                        mat-button
                        color="warn"
                        class="m-2"
                        (click)="clearFilter(); menuTrigger.closeMenu()"
                      >
                        Clear
                      </button>
                    </div>
                  </form>
                </div>
              </mat-menu>
            </div>
            <!-- <div class="m-2 d-flex">
              <mat-icon class="material-symbols-outlined" style="color: rgb(160, 160, 160)">more_vert</mat-icon>
            </div> -->
          </div>

          <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? toggleAllRows() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                  [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                </mat-checkbox>
              </td>
            </ng-container>

            <!-- Position Column -->
            <!-- <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>No.</th>
            <td mat-cell *matCellDef="let element">{{ element.id }}</td>
          </ng-container> -->
            <!-- Name Column -->
            <ng-container matColumnDef="Name">
              <th translate mat-header-cell *matHeaderCellDef mat-sort-header style="width: 200px;">Name</th>
              <td mat-cell *matCellDef="let element">
                {{ element.first_name }} {{ element.last_name }}
              </td>
            </ng-container>
            <ng-container matColumnDef="Course_name">
              <th translate mat-header-cell *matHeaderCellDef mat-sort-header style="width: 150px;">Course</th>
              <td mat-cell *matCellDef="let element">
                {{ element.course_name }}
              </td>
            </ng-container>
            <ng-container matColumnDef="phone_number">
              <th translate mat-header-cell *matHeaderCellDef>Mobile Number</th>
              <td mat-cell *matCellDef="let element">
                {{ element.phone_number }}
              </td>
            </ng-container>
            <ng-container matColumnDef="email">
              <th translate mat-header-cell *matHeaderCellDef style="width: 250px;">Email</th>
              <td mat-cell *matCellDef="let element">{{ element.email }}</td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="Dost_ID">
              <th translate mat-header-cell *matHeaderCellDef mat-sort-header>Dost ID</th>
              <td mat-cell *matCellDef="let element">{{ element.Dost_ID }}</td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="Roll_No">
              <th translate mat-header-cell *matHeaderCellDef mat-sort-header>Roll No</th>
              <td mat-cell *matCellDef="let element">
                {{ element.roll_number }}
              </td>
            </ng-container>
            <!-- <ng-container matColumnDef="Department">
          <th mat-header-cell *matHeaderCellDef>Department</th>
          <td mat-cell *matCellDef="let element">{{ element.course_name }}</td>
        </ng-container> -->
            <ng-container matColumnDef="Academic_Year">
              <th translate mat-header-cell *matHeaderCellDef mat-sort-header>
                Academic Year
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.Academic_Year }}
              </td>
            </ng-container>
            <ng-container matColumnDef="Action" stickyEnd>
              <th translate mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
              <td mat-cell *matCellDef="let element">
                <div class="d-flex align-items-center">
                  <p translate *ngIf="actiondata?.view" (click)="gotostudentview(element)" class="mb-0 cursor_pointer">
                    View
                  </p>

                  <!-- 3-dots menu for edit option -->
                  <ng-container *ngIf="actiondata?.edit">
                    <div class="action_button" [matMenuTriggerFor]="menu" aria-label="Actions">
                      <i class="fa-solid fa-ellipsis-vertical"></i>
                    </div>
                    <mat-menu #menu="matMenu">
                      <p class="m-0" mat-menu-item (click)="editForm(element)">
                        <!-- <mat-icon>edit</mat-icon> -->
                        <span translate>Edit</span>
                      </p>
                    </mat-menu>
                  </ng-container>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="selection.toggle(row)"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td translate class="mat-cell" colspan="4">No data</td>
            </tr>
          </table>
        </div>
        <div class="mt-2" *ngIf="total_count > 5">
          <app-pagination [datafromparent]="total_count" (onDatePicked)="pagination($event)"></app-pagination>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="showaddflag">
    <div class="">
      <div class="d-flex align-items-center">
        <div>
          <button mat-icon-button class="back_icon me-2" (click)="showadd(false)">
            <i class="fa-solid fa-arrow-left"></i>
          </button>
        </div>
        <!-- <div>
          <button (click)="editform()">edit</button>
        </div> -->
        <div>
          <h4 class="m-0">
            {{ isEditMode ? "Edit Students" : "Add Students" }}
          </h4>
        </div>
      </div>
      <div class="wrapper">
        <mat-stepper labelPosition="bottom" [linear]="true" #stepper class="form-stepper bg-transparent">
          <mat-step label="Step 1">
            <div class="mt-4">
              <h4 translate>1. Student Details</h4>
            </div>
            <form (ngSubmit)="onSubmit()" [formGroup]="StudentPersonalForm">
              <div class="row">
                <div class="col-sm-8">
                  <div class="row">
                    <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                      <app-question [question]="StudentPersonalFormQuestions[0]"
                        [form]="StudentPersonalForm"></app-question>
                    </div>
                    <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                      <app-question [question]="StudentPersonalFormQuestions[1]"
                        [form]="StudentPersonalForm"></app-question>
                    </div>
                    <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                      <app-question [question]="StudentPersonalFormQuestions[2]"
                        [form]="StudentPersonalForm"></app-question>
                    </div>
                    <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                      <app-question [question]="StudentPersonalFormQuestions[3]"
                        [form]="StudentPersonalForm"></app-question>
                    </div>
                    <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                      <app-question [question]="StudentPersonalFormQuestions[4]"
                        [form]="StudentPersonalForm"></app-question>
                    </div>
                    <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                      <app-question [question]="StudentPersonalFormQuestions[5]"
                        [form]="StudentPersonalForm"></app-question>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 d-flex align-items-center justify-content-center">
                  <div class="m-2">
                    <input #csvInput hidden="true" type="file" onclick="this.value=null"
                      (change)="imageInputChange($event)" accept="image/png, image/jpeg" />
                    <div>
                      <img *ngIf="!selectedImageUrl; else showImage" src="../../../assets/icons/Upload photo icon.svg"
                        aria-hidden="false" (click)="csvInput.click()"
                        style="cursor: pointer; width: 200px; height: 200px" />
                      <ng-template #showImage>
                        <img [src]="selectedImageUrl" alt="Selected Image" (click)="csvInput.click()"
                          style="width: 200px; height: 200px; cursor: pointer" />
                      </ng-template>
                      <p translate class="text-center mt-1">Upload Your Photo</p>
                    </div>
                    <p Upload Your Photo *ngIf="fileName" class="text-center mt-1">
                      Selected file: {{ fileName }}
                    </p>
                  </div>
                </div>
                <div *ngFor="let question of filterdata"
                  class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                  <app-question [question]="question" [form]="StudentPersonalForm"></app-question>
                </div>
              </div>
            </form>
          </mat-step>

          <mat-step label="Step 2">
            <div class="mb-2">
              <ng-container *ngIf="educationaddformarry.length > 0">
                <div class="row">
                  <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4" *ngFor="
                      let arrayform of educationaddformarry;
                      let i = index
                    ">
                    <div class="card position-relative">
                      <div class="m-2 px-2">
                        <div>
                          <b>{{ arrayform.qualification_id }}</b>
                        </div>
                        <div>{{ arrayform.course_name }}</div>
                        <div class="mt-3">
                          <div translate>
                            Year of passing :
                            <span>{{
                              arrayform.end_year | date : "yyyy"
                              }}</span>
                          </div>
                          <div>
                            Pass Percentage :
                            <span>{{ arrayform.percentage }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="position-absolute top-0 end-0">
                        <div class="action_button" [matMenuTriggerFor]="menu" aria-label="Actions">
                          <i class="fa-solid fa-ellipsis-vertical"></i>
                        </div>
                        <mat-menu #menu="matMenu">
                          <button mat-menu-item class="update_button" (click)="editarrayform(arrayform, i)">
                            <span translate>Edit</span>
                          </button>
                          <button mat-menu-item class="delete_button" (click)="deletearrayform(i)">
                            <span translate>Delete</span>
                          </button>
                        </mat-menu>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
            <form [formGroup]="StudentEducationForm">
              <div class="mt-4">
                <h4 translate>2. Education Details</h4>
              </div>
              <div class="row">
                <div *ngFor="let question of StudentEducationalFormQuestions"
                  class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                  <app-question [question]="question" [form]="StudentEducationForm"></app-question>
                </div>
              </div>
              <div class="d-flex">
                <button translate class="me-3 cancel_button" type="submit" mat-raised-button (click)="reseteducationform()">
                  Cancel
                </button>
                <!-- <button type="submit" mat-raised-button color="primary" (click)="arraySubmit()" [disabled]="!StudentEducationForm.valid">
                  Add Details
                </button> -->
                <ng-container *ngIf="editeducationarrayflag">
                  <button translate type="submit" mat-raised-button color="primary" class="submit_button" (click)="arraySubmit()"
                    [disabled]="!StudentEducationForm.valid">
                    Add Details
                  </button>
                </ng-container>
                <ng-container *ngIf="!editeducationarrayflag">
                  <button translate type="submit" mat-raised-button color="primary" class="update_button"
                    (click)="editarrySubmit()" [disabled]="!StudentEducationForm.valid">
                    Update Details
                  </button>
                </ng-container>
              </div>
            </form>
          </mat-step>

          <mat-step label="Step 3" [stepControl]="StudentAddressForm">
            <div class="mt-4">
              <h4 translate>3. Family Details</h4>
            </div>
            <!-- <form (ngSubmit)="onSubmit()" [formGroup]="StudentAddressForm"> -->
            <div class="row">
              <div *ngFor="let question of StudentFamilyFormQuestions"
                class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                <app-question [question]="question" [form]="StudentFamilyForm"></app-question>
              </div>
              <div>
                <div>
                  <h4 translate>Present Address</h4>
                </div>
                <form [formGroup]="StudentPresentAddressForm">
                  <div class="row">
                    <div *ngFor="let question of StudentAddressFormQuestions"
                      class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                      <app-question [question]="question" [form]="StudentPresentAddressForm"></app-question>
                    </div>
                  </div>
                </form>
              </div>
              <div>
                <mat-checkbox class="mb-3" [(ngModel)]="checked" [(indeterminate)]="indeterminate"
                  (click)="addresscheckbox()" [disabled]="!StudentPresentAddressForm.valid">
                  <span translate>Permanent Address is same as Present Address</span>
                </mat-checkbox>
              </div>
              <div>
                <div>
                  <h4 translate>Permanent Address</h4>
                </div>
                <form [formGroup]="StudentPermanentAddressForm">
                  <div class="row">
                    <div *ngFor="
                        let question of StudentAddressFormQuestions;
                        let i = index
                      " class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                      <app-question [question]="changingids(question, i)"
                        [form]="StudentPermanentAddressForm"></app-question>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <!-- </form> -->
          </mat-step>
        </mat-stepper>
      </div>
      <!-- remove the next button and add the back button -->
      <div class="form-row d-flex justify-content-end my-3 py-2 bg-white">
        <!-- Back button always visible -->
        <button translate mat-stroked-button color="primary" class="px-5 previous_button cancel_button mx-2"
          (click)="stepper.previous()" [disabled]="stepper.selectedIndex === 0">
          Back
        </button>
        <button mat-raised-button color="primary" class="px-5 submit_button mx-2" *ngIf="
            stepper.selectedIndex === stepper.steps.length - 1 &&
            StudentPresentAddressForm.valid &&
            StudentPermanentAddressForm.valid
          " (click)="onSubmit()">
          {{ isEditMode ? ("Update" | translatepipe) : ("Submit" | translatepipe) }}
        </button>
        <!-- <button mat-raised-button color="primary" class="px-5 mx-2"
          *ngIf="stepper.selectedIndex !== stepper.steps.length - 1" (click)="onSubmit()"
          [disabled]="!StudentPersonalForm.valid">
          Save
        </button> -->
        <button translate mat-raised-button color="primary" class="px-5 add_button mx-2"
          *ngIf="stepper.selectedIndex !== stepper.steps.length - 1" (click)="stepper.next()"
          [disabled]="!StudentPersonalForm.valid">
          Continue
        </button>
      </div>
    </div>
  </ng-container>
</section>